
const sh = require('shelljs')
const fs = require('fs')
const path = require('path')
const execAsync = require('libraries/execAsync')
const {
	accent, primary, warn, newline,
	config, inquirer, spinner, globals,
	ROOT_TO_WEBPACK_PATH
} = require('../common.js')

module.exports = yargs => {

	console.log(accent('ops configuration --\n'))

	_getFilepath()

	// read the package json, clip everything before the @ off,
	// see if the user folder matches any of those

}

function _getFilepath() {

	const home = process.env.HOME

	inquirer.prompt({
		type: 'input',
		name: 'filepath',
		message: `path to javascript repo:\n\t${home}/`
	}).then(({ filepath }) => {
		const result = path.join(home,filepath, ROOT_TO_WEBPACK_PATH)
		const packagePath = path.join(result, 'package.json')

		if (fs.existsSync(packagePath)) {
			config.set('ops_client_path', result)
			_guessName(packagePath)

		} else {
			warn("\tcould not find ops client code on that path,")
			warn("\tplease try again\n")
			_getFilepath()
		}

	})
}

function _guessName(packagePath) {

	newline()

	// Get pre defined usernames

	let pkg // Read the file, turn into JSON
	try {
		pkg = JSON.parse(fs.readFileSync(packagePath))
	} catch (err) { _getName() }

	// Search the package path for contributors matches

	let nameGuess

	for (var i = 0; i < pkg.contributors.length; i++) {
		const { name, email } = pkg.contributors[i]
		const match = email.split('@')[0]
		if (packagePath.includes(match)) {
			nameGuess = name
			break
		}
	}

	if (nameGuess) {

		inquirer.prompt({
			type: 'confirm',
			name: 'correct',
			message: `is your name ${nameGuess}?`
		}).then(({ correct }) => {
			if (correct) {
				config.set('name', _resolveName(nameGuess))
				_getWebhooksUrl()
			} else {
				_getName()
			}
		})

	} else {
		_getName()
	}

}

function _getName() {

	newline()

	inquirer.prompt({
		type: 'input',
		name: 'name',
		message: `your full name:`
	}).then(({ name }) => {

		if (name) {
			config.set('name', _resolveName(name))
			_getWebhooksUrl()
		} else {
			warn("\tplease provide a valid name")
			_getName()
		}

	})

}

function _getWebhooksUrl() {

	newline()

	inquirer.prompt({
		type: 'input',
		name: 'webhookUrl',
		message: 'slack webhooks url:'
	}).then(({ webhookUrl }) => {
		config.set('slack_webhook_url', { qa: webhookUrl })
		_getTextEditor()
	})
}

function _getTextEditor() {

	newline()
	const editorLookup = {
		'atom': "Atom",
		'sublime': "Sublime Text",
		'vs code': "Visual Studio Code"
	}

	inquirer.prompt({
		type: 'list',
		name: 'editor',
		choices: Object.keys(editorLookup),
		message: 'preferred text editor:'
	}).then(({ editor }) => {
		editor = editorLookup[editor]
		config.set('preferred_editor', editor)
		newline()
		_install()
	})
}

function _install() {

	spinner.start('installing global dependencies')

	execAsync(
		`npm install -g ${globals.join(" ")}`,
		{ silent: true }
	).then(() => {
		spinner.stop()
		_end()
	})
}

function _end() {
	console.log(accent("\tops cli has been configured\n"))
	console.log("\treconfigure at any time with " +  accent("ops config\n"))
}

function _resolveName(name) {
	return {
		first: name.split(' ')[0],
		last: name.split(' ').pop(),
		full: name
	}
}



// WEBPACK FOOTER //
// ./src/commands/config.js